import { useMemo } from "react";
import { Link } from "react-router-dom";
import { FaSpinner } from "../utils/icons";
import { useProjectsQuery } from "../hooks/useLabelingQueries";

// Reporting projects are the reader-study worklists. Reuses the shared labeling
// projects list (admins bypass the access filter, so this returns every one)
// and filters to project_type === "reporting" client-side.
export default function ReaderStudyProjects() {
  const { data, isLoading, isError } = useProjectsQuery();
  const reporting = useMemo(
    () => (data?.projects ?? []).filter((p) => p.project_type === "reporting"),
    [data],
  );

  if (isLoading) {
    return (
      <div className="p-8 text-fg-muted flex items-center gap-2">
        <FaSpinner className="animate-spin" /> Loading reporting projects…
      </div>
    );
  }
  if (isError) {
    return <div className="p-8 text-warn">Failed to load projects.</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6 text-fg">
      <h1 className="text-2xl font-bold mb-1">Reader studies</h1>
      <p className="text-sm text-fg-muted mb-5">
        Live monitoring for reporting projects — pick a study for per-reader progress and
        reading-time metrics.
      </p>
      {reporting.length === 0 ? (
        <div className="text-fg-muted text-sm border border-border rounded-frame p-6">
          No reporting projects found.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {reporting.map((p) => (
            <Link
              key={p.project_id}
              to={`/admin/reader-study/${encodeURIComponent(p.project_id)}`}
              className="block bg-surface-2 border border-border rounded-frame p-4 hover:border-signal-stroke-soft hover:bg-signal-ambient transition-colors"
            >
              <div className="font-semibold">{p.name}</div>
              <div className="text-xs text-fg-muted font-mono mt-0.5">{p.project_id}</div>
              <div className="text-sm text-fg-muted mt-2">
                {p.total_cases} {p.total_cases === 1 ? "case" : "cases"}
                {p.assigned_to ? ` · ${p.assigned_to.name}` : ""}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
